import { tv } from 'tailwind-variants';

import { createEnumVariants } from '../../../utils/commonTailwindVariants.utils';

import { SegmentedControlType } from './SegmentedControl.consts';

/**
 * Styles for the main SegmentedControl container component
 */
export const segmentedControlStyles = tv({
  base: 'border-1 flex w-full justify-center rounded-md transition-all duration-100',
  variants: {
    controlType: createEnumVariants<typeof SegmentedControlType>({
      [SegmentedControlType.SOLID_HIGHLIGHT]:
        'border-primary-border [&>*:not(:last-child)]:border-r-1 [&>*:not(:last-child)]:border-r-primary-border inline-flex max-w-[480px]',
      [SegmentedControlType.SOLID_COLOR]:
        'border-primary-active hover:border-primary-highlight flex w-full items-center justify-center gap-[3px] p-[3px]',
      [SegmentedControlType.SOLID]: 'gap-[3px] border border-white/10 p-[3px]'
    })
  }
});

/**
 * Styles for the individual segment elements
 */
export const segmentStyles = tv({
  base: 'items-center justify-center gap-2 px-0.5 py-1 text-center outline-none',
  variants: {
    controlType: createEnumVariants<typeof SegmentedControlType>({
      [SegmentedControlType.SOLID]: 'w-full rounded-[4px] py-0',
      [SegmentedControlType.SOLID_COLOR]: 'w-full rounded-[4px]',
      [SegmentedControlType.SOLID_HIGHLIGHT]: 'inline-flex w-40'
    }),
    isSelected: {
      true: 'cursor-default',
      false: 'cursor-pointer transition-colors duration-100'
    },
    isFirstSegment: {
      true: '',
      false: ''
    },
    isLastSegment: {
      true: '',
      false: ''
    },
    selectionState: {
      selected: '',
      unselected: '',
      default: ''
    }
  },
  compoundVariants: [
    // SOLID type variants
    {
      controlType: SegmentedControlType.SOLID,
      selectionState: 'selected',
      className: 'bg-white/10'
    },
    {
      controlType: SegmentedControlType.SOLID,
      selectionState: 'unselected',
      className: 'hover:bg-white/5'
    },
    // SOLID_COLOR type variants
    {
      controlType: SegmentedControlType.SOLID_COLOR,
      selectionState: 'selected',
      className: 'bg-primary-active'
    },
    {
      controlType: SegmentedControlType.SOLID_COLOR,
      selectionState: 'unselected',
      className: 'hover:bg-white/10'
    },
    // SOLID_HIGHLIGHT type variants
    {
      controlType: SegmentedControlType.SOLID_HIGHLIGHT,
      selectionState: 'selected',
      className:
        'shadow-segment-selected from-solid-gradient-start to-solid-gradient-end bg-gradient-to-r'
    },
    {
      controlType: SegmentedControlType.SOLID_HIGHLIGHT,
      isFirstSegment: true,
      className: 'rounded-l-md'
    },
    {
      controlType: SegmentedControlType.SOLID_HIGHLIGHT,
      isLastSegment: true,
      className: 'rounded-r-md'
    }
  ]
});
